import { render, staticRenderFns } from "./AwardInformationPopup.vue?vue&type=template&id=f44bb1d2"
import script from "./AwardInformationPopup.vue?vue&type=script&lang=js"
export * from "./AwardInformationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports